const inviteUploaderForm = {
  toggleButton: "+ Invite a new data uploader by email",
  heading: "Invite new data uploader",
  successMessage: 'Invitation sent to {{email}} for {{org}}',
  selectedOrgFallback: "selected org",
  organizationPlaceholder: "-- Select organization --",
  addNewOrganizationOption: "+ Add new organization...",
  newOrgNamePlaceholder: "New organization name (e.g. Landspitali)",
  emailPlaceholder: "uploader@hospital.com",
  sendButton: "Send Invite",
  sending: "Sending...",
  alerts: {
    invalidEmail: "Please enter a valid email",
    selectOrganization: "Please select an organization",
    enterNewOrgName: "Please enter the new organization name",
    sendFailed: "Failed to send invitation",
  },
};

export default inviteUploaderForm;
